
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Switch } from "@/components/ui/switch";
import { Badge } from "@/components/ui/badge";
import { Smartphone } from "lucide-react";
import { format } from "date-fns";
import { ProfileData } from "@/types/profile";

interface TwoFactorMethod {
  id: string;
  method: string;
  verified: boolean;
  last_used: string | null;
}

interface TwoFactorAuthProps {
  profile: ProfileData | null;
  twoFactorMethods: TwoFactorMethod[];
  toggleTwoFactor: (args: { method: string; enable: boolean; }) => void;
  isTogglingTwoFactor: boolean;
}

const TwoFactorAuth = ({ profile, twoFactorMethods, toggleTwoFactor, isTogglingTwoFactor }: TwoFactorAuthProps) => {

  const handleTwoFactorToggle = (method: string, enabled: boolean) => {
    toggleTwoFactor({ method, enable: enabled });
  };
  
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Smartphone className="h-5 w-5" />
          Two-Factor Authentication
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="flex items-center justify-between">
          <div>
            <h4 className="font-medium">Two-Factor Authentication</h4>
            <p className="text-sm text-gray-600">Add an extra layer of security to your account</p>
          </div>
          <Switch
            checked={profile?.two_factor_enabled || false}
            onCheckedChange={(checked) => handleTwoFactorToggle('totp', checked)}
            disabled={isTogglingTwoFactor}
          />
        </div>
        
        {twoFactorMethods.length > 0 && profile?.two_factor_enabled && (
          <div className="space-y-2">
            <h5 className="text-sm font-medium">Active Methods</h5>
            {twoFactorMethods.map((method) => (
              <div key={method.id} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <div className="flex items-center gap-2">
                  <Badge variant={method.verified ? "default" : "secondary"}>
                    {method.method.toUpperCase()}
                  </Badge>
                  <span className="text-sm">
                    {method.verified ? "Verified" : "Pending verification"}
                  </span>
                </div>
                {method.last_used && (
                  <span className="text-xs text-gray-500">
                    Last used: {format(new Date(method.last_used), 'MMM dd')}
                  </span>
                )}
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TwoFactorAuth;
